<template>
  <!-- Modal 1-->
  <div class="modal fade" id="aptamil1" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
       aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-lg-4">
              <h3>Aptamil 1</h3>
              <p class="text-center">Lapte de început 0 – 6 luni</p>
              <img class="img-fluid" src="../../../assets/images/pentru-imunitate/item1_first.png">
            </div>
            <div class="col-lg-8">
              <div class="scroll-vertical-band">
                <ul class="nav nav-tabs" id="myTab" role="tablist">
                  <li class="nav-item">
                    <a class="nav-link active" id="home1-tab" data-toggle="tab" href="#home1"
                       role="tab" aria-controls="home1" aria-selected="true">Listă ingrediente</a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" id="profile1-tab" data-toggle="tab" href="#profile1"
                       role="tab" aria-controls="profile1" aria-selected="false">Ghid de
                      alimentație</a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" id="contact1-tab" data-toggle="tab" href="#contact1"
                       role="tab" aria-controls="contact1" aria-selected="false"> Declarație
                      nutrițională</a>
                  </li>
                </ul>
              </div>
              <div class="tab-content" id="myTabContent">
                <div class="tab-pane fade show active" id="home1" role="tabpanel"
                     aria-labelledby="home1-tab">
                  <p>Lactoză (din <strong>lapte</strong> de vacă), uleiuri vegetale (ulei de floarea soarelui bogat în acid oleic, ulei de cocos, ulei de rapiță, ulei de floarea soarelui), <strong>lapte</strong> de vacă degresat, zer demineralizat (din <strong>lapte</strong> de
                    vacă), galactooligozaharide (din <strong>lapte</strong> de vacă), concentrat din zer (din <strong>lapte</strong> de vacă), proteină din <strong>lapte</strong> de vacă, fructooligozaharide, ulei de <strong>pește</strong>, citrat de potasiu, carbonat de calciu,
                    ulei din Mortierella alpina, clorură de magneziu, clorură de colină, fosfat tricalcic, citrat de sodiu, clorură de potasiu, clorură de sodiu, acid L-ascorbic, emulsifiant (lecitine (<strong>soia</strong>)), inozitol, L-triptofan, L-ascorbat de sodiu, sulfat
                    feros, sulfat de zinc, L-carnitină, antioxidant (ascorbil palmitat), D-pantotenat de calciu, nicotinamidă, sulfat de cupru, DL-alfa-tocoferil acetat, retinil palmitat, hidroclorură de tiamină, riboflavină, hidroclorură de piridoxină, iodură de potasiu, acid
                    pteroilmonoglutamic, fitomenadionă, selenit de sodiu, sulfat de mangan, colecalciferol, D-biotină, cianocobalamină.</p>
                </div>
                <div class="tab-pane fade" id="profile1" role="tabpanel" aria-labelledby="profile1-tab">
                  <ol>
                    <li>Spală-te bine pe mâini, sterilizează toate ustensilele utilizate în prepararea laptelui și asigură-te că marginea ambalajului este curată.</li>
                    <li>Fierbe apa potabilă pentru prepararea laptelui timp de 5 minute, apoi lasă la răcit până la cca 40°C. Toarnă în recipientul pregătit (biberon) cantitatea de apă fiartă şi răcită, necesară conform dozării pentru o masă.</li>
                    <li>Dozează pudra cu linguriţa din capacul ambalajului, nivelată cu ajutorul marginii din interiorul cutiei. Adaugă pudra conform tabelului de dozare în recipientul pregătit (biberon).</li>
                    <li>Închide recipientul şi agită vertical și viguros timp de 10 secunde. Este foarte important să respecți modalitatea și timpul de agitare pentru a dizolva corect pudra.</li>
                    <li>Verifică pe încheietura mâinii tale temperatura laptelui preparat (cca 37°C).</li>
                  </ol>
                </div>
                <div class="tab-pane fade box-shadow" id="contact1" role="tabpanel" aria-labelledby="contact1-tab">
                  <div class="row height-row">
                    <div class="col-md-4 col-4 border-table">
                      <span class="span-black pl-0">Declaraţie nutriţională</span>
                    </div>
                    <div class="col-md-4 col-4 border-table"><span
                        class="span-black">100 g pudră </span>
                    </div>
                    <div class="col-md-4 col-4 border-table border-last">
                      <span class="span-black">100 ml lapte reconstituit (13,7 g pudră)</span>
                    </div>
                  </div>

                  <valoare></valoare>
                  <grasimi></grasimi>
                  <glucide></glucide>
                  <polioli></polioli>
                  <fibre></fibre>
                  <proteine></proteine>
                  <vitamine></vitamine>
                  <alte></alte>

                  <p style="color: #A0A0A0; font-size: 12px; padding-left: 15px"> * pot apărea variații naturale în materia primă</p>
                </div>

              </div>

            </div>

          </div>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
import Grasimi from "./Table/grasimi";
import Valoare from "./Table/valoare";
import Glucide from "./Table/glucide";
import Polioli from "./Table/polioli";
import Fibre from "./Table/fibre";
import Proteine from "./Table/proteine";
import Vitamine from "./Table/vitamine";
import Alte from "./Table/alte";

export default {
  components: {
    Grasimi,
    Valoare,
    Glucide,
    Polioli,
    Fibre,
    Proteine,
    Vitamine,
    Alte,
  },
  data() {
    return {}
  },
}
</script>
